import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { ILink } from '../../../types/link';
import { VehicleValue } from '../Vehicles';
import TimeAgo, { type Formatter } from 'react-timeago';
import dayjs from 'dayjs';

const formatter: Formatter = (value, unit, suffix) => {
  if (suffix === 'ago') return 'Reserve';
  return `${value}${unit.charAt(0)}`;
}

export default function vehicleReserveCell(
  reserve: (vehicleId: number) => void,
  open: (vehicleId: number) => void,
) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      const vehicle = this.props.dataItem as VehicleValue;
      return (
        <td {...this.props.tdProps}>
          <button
            disabled={vehicle.Links.filter((x: ILink) => x.Name === "VehicleReserve").length === 0}
            className={`btn btn-sm ${vehicle.IsReserved ?
              (vehicle.IsReservedByMe ? 'btn-danger' : 'btn-warning') :
              'btn-success'}`}
              onClick={(e) => {
                if (vehicle.IsReserved) {
                  open(vehicle.VehicleID);
                } else {
                  reserve(vehicle.VehicleID);
                }
                e.preventDefault();
              }}
            >{vehicle.IsReserved ? <TimeAgo
              title=""
              date={dayjs.utc(vehicle.ReserveExpiry).toDate()}
              formatter={formatter}
            /> : 'Reserve'}
            </button>
        </td>
      );
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
      return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
    }
  };
}
